import { useCallback, useState } from 'react';

export const useGallery = () => {
  const [openGallery, setOpenGallery] = useState<boolean>(false);
  const [activeItem, setActiveItem] = useState<number>(0);

  const handleOpenGallery = useCallback((index: number) => {
    setOpenGallery(true);
    setActiveItem(index);
  }, []);

  const handleCloseGallery = useCallback(() => {
    setOpenGallery(false);
  }, []);

  return { openGallery, activeItem, handleOpenGallery, handleCloseGallery };
};
